import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { ShoppingBag, User, LogOut, Menu, X, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  
  // Check if we're on an inside page (not home)
  const isInsidePage = location.pathname !== '/';

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setMobileMenuOpen(false);
    navigate('/login');
  };

  const getDashboardLink = () => {
    if (!user) return '/login';
    if (user.userType === 'admin') return '/admin-dashboard';
    if (user.userType === 'artist') return '/artist-dashboard';
    return '/buyer-dashboard';
  };

  const closeMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className="navbar" data-testid="navbar">
      <div className="navbar-content">
        <Link to="/" className="logo" data-testid="logo-link" onClick={closeMenu}>
          <img 
            src="/artcardo-logo.png" 
            alt="ARTCARDO Logo" 
            style={{height: '300px', width: 'auto', display: 'block'}}
          />
        </Link>

        {/* Mobile Menu Toggle */}
        <button 
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          data-testid="mobile-menu-toggle"
        >
          {mobileMenuOpen ? <X size={32} color="#fff" /> : <Menu size={32} color="#fff" />}
        </button>

        {/* Desktop & Mobile Menu */}
        <ul className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <li>
            <Link to="/" data-testid="nav-home" onClick={closeMenu} className="flex items-center gap-1">
              <Home className="w-4 h-4" />
              Home
            </Link>
          </li>
          <li><Link to="/products" data-testid="nav-products" onClick={closeMenu}>Products</Link></li>
          <li><Link to="/artists" data-testid="nav-artists" onClick={closeMenu}>Artists</Link></li>
          <li><Link to="/about" data-testid="nav-about" onClick={closeMenu}>About</Link></li>
          <li><Link to="/contact" data-testid="nav-contact" onClick={closeMenu}>Contact</Link></li>
          {user ? (
            <>
              <li>
                <Link to={getDashboardLink()} data-testid="nav-dashboard" onClick={closeMenu}>
                  <Button variant="ghost" size="sm" style={{color: '#ffffff', background: 'transparent'}}>
                    <User className="w-4 h-4 mr-2" />
                    Dashboard
                  </Button>
                </Link>
              </li>
              <li>
                <Button variant="ghost" size="sm" onClick={handleLogout} data-testid="logout-btn" style={{color: '#ffffff', background: 'transparent'}}>
                  <LogOut className="w-4 h-4 mr-2" />
                  Logout
                </Button>
              </li>
            </>
          ) : (
            <li>
              <Link to="/login" data-testid="nav-login" onClick={closeMenu}>
                <Button size="sm" style={{background: '#ef4444', color: '#ffffff', border: 'none'}}>
                  Login
                </Button>
              </Link>
            </li>
          )}
        </ul>
      </div>
      
      {/* Floating Home Button on Inside Pages */}
      {isInsidePage && (
        <Link 
          to="/" 
          className="fixed bottom-6 left-6 z-50 bg-black hover:bg-[#ef4444] text-white p-4 rounded-full shadow-lg transition-all duration-300 flex items-center gap-2 group"
          data-testid="floating-home-btn"
        >
          <Home className="w-5 h-5" />
          <span className="max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-300 whitespace-nowrap">
            Back to Home
          </span>
        </Link>
      )}
    </nav>
  );
};

export default Navbar;